/**
 * ehr#571 (reopen) - the note editor's sign-off button and its "Save your changes?" check, kept
 * here as plain functions so they can be tested without the editor.
 */

/**
 * The author's own button: a returned note resubmits as the next round (Supervision not known
 * yet counts as on there: it came back from a supervisor); otherwise it says where the note goes,
 * to the supervisor while the clinician's Supervision is on, else signed off alone.
 */
export function authorSignLabel(o: {
  status: string;
  /** The clinician's Supervision setting; null while not known. */
  supervisionRequired: boolean | null;
  round: number;
}): string {
  if (o.status === 'changes' && o.supervisionRequired !== false)
    return `Resubmit, round ${o.round + 1}`;
  return o.supervisionRequired ? 'Submit to Supervisor' : 'Sign Off Note';
}

/**
 * Unsaved changes: the note differs from how it was when the person first touched it (or last
 * saved it). An untouched note (base null), a locked one and a read-only one never ask.
 */
export function isUnsaved(o: {
  base: string | null;
  now: string;
  locked: boolean;
  viewOnly: boolean;
}): boolean {
  return !o.locked && !o.viewOnly && o.base !== null && o.now !== o.base;
}
